import { api, dynamic } from './api';
import CacheStorage from './CacheStorage';

const baseURL = `${process.env.REACT_APP_API_URL}api`;

const cacheStorage = new CacheStorage();

const updateCachedTraining = async (id, data) => {
  const url = `${baseURL}/training/${id}`;
  await cacheStorage.updateCache(data, url);
};

const updateCachedTrainingList = async (data) => {
  const url = `${baseURL}/training/?page=1&pageSize=10`;
  const items = await cacheStorage.getFromCache(url);

  if (items && items.itemList) {
    const element = items.itemList.find((el) => el.id === data.id);

    if (element == null) {
      items.itemList = items.itemList.concat([data]);
      items.rowCount += 1;
    } else {
      items.itemList[items.itemList.indexOf(element)] = data;
    }

    await cacheStorage.updateCache(items, url);
  }
};

const updateReportFilter = async (data) => {
    const url = `${baseURL}/training/filter`;
    await cacheStorage.updateCache(data, url);
};
const updateReport = async (data) => {
    const url = `${baseURL}/training`;
    await cacheStorage.updateCache(data, url);
};
const getBackPaged = async () => {
    const url = `${baseURL}/training/filter`;
    const items = await cacheStorage.getFromCache(url);
    return items || undefined;
};

const fetchTraining = async () => {
  await api.getAll('/training/?page=1&pageSize=10');
  await dynamic.getAll('trainingdata', { params: { page: 0 } });
  await dynamic.getAll('traininglocation', { params: { page: 0 } });
  await dynamic.getAll('traininglanguage', { params: { page: 0 } });
  await dynamic.getAll('trainingmethod', { params: { page: 0 } });
  await dynamic.getAll('trainingassessmentmethod', { params: { page: 0 } });
};

const TrainingRepository = {
  fetchTraining,
  updateCachedTrainingList,
  updateCachedTraining,
  updateReport,
  updateReportFilter,
  getBackPaged,
};
export default TrainingRepository;
